import { render, staticRenderFns } from "./ItemFilterModalFilterLayout.vue?vue&type=template&id=5462fafe&scoped=true"
import script from "./ItemFilterModalFilterLayout.vue?vue&type=script&lang=js"
export * from "./ItemFilterModalFilterLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5462fafe",
  null
  
)

export default component.exports